export class Percentage {
  private _percentage: number

  constructor (percentage: number) {
    if (this.checkNumber(percentage)) {
      throw new TypeError('Percentage can\'t be less than 0 and greater than 100')
    } else { this._percentage = percentage }
  }

  private checkNumber (number: number): boolean {
    return (number > 100 || number < 0)
  }

  percentage (): number {
    return this._percentage
  }

  add (anotherPercentaje: Percentage): Percentage {
    const result = this._percentage + anotherPercentaje.percentage()
    if (this.checkNumber(result)) {
      throw new TypeError('Percentage can\'t be less than 0 and greater than 100')
    } else { return new Percentage(result) }
  }

  subtract (anotherPercentaje: Percentage): Percentage {
    const result = this._percentage - anotherPercentaje.percentage()
    if (this.checkNumber(result)) {
      throw new TypeError('Percentage can\'t be less than 0 and greater than 100')
    } else { return new Percentage(result) }
  }

  multiply (number: number): number {
    return this._percentage * number
  }

  toString (): string {
    const parsedNumber = '' + this._percentage
    return parsedNumber.replace('.', ',')
  }
}
